/* Header-Zustand: oben transparent, nach dem Scrollen leicht abgedunkelt. */
(function () {
  'use strict';
  var body = document.body;
  if (!body) return;
  function sync() {
    body.classList.toggle('ns-scrolled', (window.scrollY || window.pageYOffset || 0) > 24);
  }
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  sync();
})();
